function normalizeHex(value) {
  const raw = String(value || "").trim().replace(/^#/, "");
  if (/^[0-9a-fA-F]{3}$/.test(raw)) {
    return `#${raw
      .split("")
      .map((c) => c + c)
      .join("")
      .toLowerCase()}`;
  }
  if (/^[0-9a-fA-F]{6}$/.test(raw)) return `#${raw.toLowerCase()}`;
  return "";
}

function rgbToHex(rgbLike) {
  const match = String(rgbLike || "")
    .trim()
    .match(/^rgba?\(([^)]+)\)$/i);
  if (!match) return "";
  const parts = match[1]
    .split(",")
    .map((v) => Number(v.trim()))
    .slice(0, 3);
  if (parts.length !== 3 || parts.some((n) => !Number.isFinite(n) || n < 0 || n > 255)) {
    return "";
  }
  return `#${parts.map((n) => Math.round(n).toString(16).padStart(2, "0")).join("")}`;
}

/**
 * Parse CSS color formats used by backend branding into a normalized hex value.
 * Returns empty string for invalid/unsupported values.
 */
export function parseCssColorToHex(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  return normalizeHex(raw) || rgbToHex(raw) || "";
}

/**
 * Optional helper for backgrounds if consumers need a best-effort URL.
 */
export function pickBackgroundSampleUrl(userData) {
  if (!userData || typeof userData !== "object") return "";
  const desk = typeof userData.background_desk === "string" ? userData.background_desk.trim() : "";
  const mob = typeof userData.background_mob === "string" ? userData.background_mob.trim() : "";
  return desk || mob || "";
}
